import { z } from "zod";

export type IApiPropertyFinanceInfoField = z.infer<typeof TApiPropertyFinanceInfoField>;
export const TApiPropertyFinanceInfoField = z
  .object({
    balanceSheetValue: z.number(),
    grossYield: z.number(),
    initialLoan: z.number(),
    jointCost: z.number(),
    marketValue: z.number(),
    purchaseDate: z.string(),
    purchaseSum: z.number(),
    remainingLoan: z.number(),
    totalJointCost: z.number(),
  })
  .partial();

export type IApiPropertyGeneralInfoField = z.infer<typeof TApiPropertyGeneralInfoField>;
export const TApiPropertyGeneralInfoField = z
  .object({
    address: z.string(),
    architects: z.string(),
    bnr: z.string(),
    buildingOwner: z.string(),
    builtArea: z.number(),
    city: z.string(),
    constructionYear: z.string(),
    energyScore: z.string(),
    fireSafetyResponsibles: z.array(z.string().optional()),
    floors: z.array(z.number()),
    gnr: z.string(),
    heatedArea: z.number(),
    heatingScore: z.string(),
    insuranceCompanies: z.string(),
    jointArea: z.number(),
    location: z.array(z.number()),
    managementCompanies: z.string(),
    maxPeopleAllowed: z.number(),
    municipality: z.string(),
    municipalityNumber: z.string(),
    netArea: z.number(),
    ownedArea: z.number(),
    plotArea: z.number(),
    postalAddress: z.string(),
    primaryArea: z.number(),
    protectionClass: z.string(),
    rentableArea: z.number(),
    rentedArea: z.number(),
    riskClass: z.string(),
    secondaryArea: z.number(),
    snr: z.string(),
    totalArea: z.number(),
    totalParkingSpots: z.number(),
    usageArea: z.number(),
    visitorAddress: z.string(),
  })
  .partial();

export type IApiPropertyNoteInfoField = z.infer<typeof TApiPropertyNoteInfoField>;
export const TApiPropertyNoteInfoField = z
  .object({
    note: z.string(),
  })
  .partial();

export type IApiPropertyInfoFields = z.infer<typeof TApiPropertyInfoFields>;
export const TApiPropertyInfoFields = z
  .object({
    finance: TApiPropertyFinanceInfoField,
    general: TApiPropertyGeneralInfoField,
    note: z.string().optional(),
  })
  .partial();
